var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.749,
    height: 40.2,
    viewBox: "0 0 30.749 40.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "robot-8203",
    transform: "translate(-29.776 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M94.59,43.361H83.26a1.387,1.387,0,0,1-1.385-1.385V32.641a1.386,1.386,0,0,1,1.385-1.385H94.59a1.386,1.386,0,0,1,1.385,1.385v9.336A1.386,1.386,0,0,1,94.59,43.361ZM83.26,32.145a.5.5,0,0,0-.5.5v9.336a.5.5,0,0,0,.5.5H94.59a.5.5,0,0,0,.5-.5V32.641a.5.5,0,0,0-.5-.5H83.26Z",
    transform: "translate(-43.775 -26.312)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M98.993,50.82a1.778,1.778,0,1,1,1.778-1.778A1.78,1.78,0,0,1,98.993,50.82Zm0-2.667a.889.889,0,1,0,.889.889A.89.89,0,0,0,98.993,48.153Z",
    transform: "translate(-56.688 -39.789)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M134.98,50.82a1.778,1.778,0,1,1,1.778-1.778A1.78,1.78,0,0,1,134.98,50.82Zm0-2.667a.889.889,0,1,0,.889.889A.89.89,0,0,0,134.98,48.153Z",
    transform: "translate(-86.984 -39.789)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M70.568,57.289H68.662a.747.747,0,0,1-.747-.747v-4.7a.747.747,0,0,1,.747-.747h1.906a.445.445,0,0,1,.444.444v5.3A.445.445,0,0,1,70.568,57.289ZM68.8,56.4h1.319V51.986H68.8Z",
    transform: "translate(-32.023 -43.015)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M167.752,57.291h-1.906a.444.444,0,0,1-.444-.444v-5.3a.444.444,0,0,1,.444-.444h1.906a.748.748,0,0,1,.747.747v4.7A.747.747,0,0,1,167.752,57.291Zm-1.461-.889h1.32V51.988h-1.32Z",
    transform: "translate(-114.091 -43.018)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M120.048,18.837h-1.867a.445.445,0,0,1-.442-.5l.289-2.5a.444.444,0,0,1,.883.1l-.232,2h.869l-.232-2a.444.444,0,1,1,.883-.1l.289,2.5a.444.444,0,0,1-.441.5Z",
    transform: "translate(-73.965 -13.004)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M117.13,3.5a1.751,1.751,0,1,1,1.751-1.752A1.753,1.753,0,0,1,117.13,3.5Zm0-2.614a.862.862,0,1,0,.862.862A.863.863,0,0,0,117.13.889Z",
    transform: "translate(-71.979 0)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M111.781,83.183a15.826,15.826,0,0,1-2.857.3,15.419,15.419,0,0,1-2.835-.3.444.444,0,0,1,0-.889,13.34,13.34,0,0,0,2.835.354,13.69,13.69,0,0,0,2.857-.354.444.444,0,0,1,0,.889Z",
    transform: "translate(-63.785 -69.278)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M90.156,133.327h-15.7a.444.444,0,0,1-.444-.444V118.349a.445.445,0,0,1,.444-.444h15.7a.444.444,0,0,1,.444.444v14.534A.444.444,0,0,1,90.156,133.327ZM74.9,132.439h14.81V118.794H74.9Z",
    transform: "translate(-37.156 -99.256)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M75.853,216.612H60.837a3.409,3.409,0,0,1,0-6.818H75.853a3.409,3.409,0,1,1,0,6.818Zm-15.016-5.929a2.52,2.52,0,0,0,0,5.04H75.853a2.52,2.52,0,0,0,0-5.04Z",
    transform: "translate(-23.194 -176.612)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M70.539,224.047a1.638,1.638,0,1,1,1.638-1.638A1.64,1.64,0,0,1,70.539,224.047Zm0-2.387a.749.749,0,1,0,.749.749A.75.75,0,0,0,70.539,221.66Z",
    transform: "translate(-32.853 -185.852)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M164.922,224.047a1.638,1.638,0,1,1,1.638-1.638A1.64,1.64,0,0,1,164.922,224.047Zm0-2.387a.749.749,0,1,0,.749.749A.75.75,0,0,0,164.922,221.66Z",
    transform: "translate(-112.307 -185.852)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M116.189,236.755H109.5a.444.444,0,1,1,0-.889h6.686a.444.444,0,1,1,0,.889Z",
    transform: "translate(-66.659 -198.56)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M103.5,221.662h-7.1a.444.444,0,1,1,0-.889h7.1a.444.444,0,1,1,0,.889Z",
    transform: "translate(-55.624 -185.855)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M107.549,105.551H99.9a.445.445,0,0,1-.444-.444v-2.488a.445.445,0,0,1,.444-.444h7.651a.444.444,0,0,1,.444.444v2.488A.444.444,0,0,1,107.549,105.551Zm-7.206-.889h6.762v-1.6h-6.762Z",
    transform: "translate(-58.574 -86.014)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M32.273,128.575a2.4,2.4,0,0,1-2.394-2.395v-3.931a4.349,4.349,0,0,1,4.344-4.344H37.3a.445.445,0,0,1,.444.444v4.433a.444.444,0,0,1-.444.444H35.631a.965.965,0,0,0-.964.964v1.99A2.4,2.4,0,0,1,32.273,128.575Zm1.949-9.781a3.459,3.459,0,0,0-3.455,3.455v3.931a1.505,1.505,0,1,0,3.011,0v-1.99a1.855,1.855,0,0,1,1.853-1.852h1.228v-3.544H34.222Z",
    transform: "translate(-0.002 -99.256)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M42.651,181.809a.444.444,0,0,1-.444-.444v-1.176a.444.444,0,1,1,.889,0v1.176A.444.444,0,0,1,42.651,181.809Z",
    transform: "translate(-10.38 -151.315)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M44.6,190.019a.444.444,0,0,1-.444-.444,1.507,1.507,0,0,0-1.505-1.506.444.444,0,0,1,0-.889,2.4,2.4,0,0,1,2.394,2.395A.444.444,0,0,1,44.6,190.019Z",
    transform: "translate(-10.378 -157.574)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M30.32,190.019a.444.444,0,0,1-.444-.444,2.4,2.4,0,0,1,2.394-2.395.444.444,0,0,1,0,.889,1.507,1.507,0,0,0-1.505,1.506A.444.444,0,0,1,30.32,190.019Z",
    transform: "translate(0 -157.574)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M178.74,128.572a2.4,2.4,0,0,1-2.394-2.395v-1.99a.965.965,0,0,0-.964-.964h-1.673a.444.444,0,0,1-.444-.444v-4.433a.444.444,0,0,1,.444-.444h3.081a4.349,4.349,0,0,1,4.344,4.344v3.931A2.4,2.4,0,0,1,178.74,128.572Zm-4.586-6.237h1.228a1.855,1.855,0,0,1,1.853,1.852v1.99a1.506,1.506,0,1,0,3.011,0v-3.931a3.459,3.459,0,0,0-3.455-3.455h-2.637v3.544Z",
    transform: "translate(-120.71 -99.254)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M205.518,181.809a.444.444,0,0,1-.444-.444v-1.176a.444.444,0,1,1,.889,0v1.176A.444.444,0,0,1,205.518,181.809Z",
    transform: "translate(-147.488 -151.315)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M193.194,190.019a.444.444,0,0,1-.444-.444,2.4,2.4,0,0,1,2.394-2.395.444.444,0,0,1,0,.889,1.507,1.507,0,0,0-1.505,1.506A.444.444,0,0,1,193.194,190.019Z",
    transform: "translate(-137.112 -157.574)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M207.468,190.019a.444.444,0,0,1-.444-.444,1.508,1.508,0,0,0-1.506-1.506.444.444,0,1,1,0-.889,2.4,2.4,0,0,1,2.395,2.395A.444.444,0,0,1,207.468,190.019Z",
    transform: "translate(-147.488 -157.574)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M113.684,149.712h-4.812a.444.444,0,0,1,0-.889h4.812a.444.444,0,0,1,0,.889Z",
    transform: "translate(-66.127 -125.285)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M113.684,165.445h-4.812a.444.444,0,1,1,0-.889h4.812a.444.444,0,1,1,0,.889Z",
    transform: "translate(-66.127 -138.529)",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.500bdee408d2ace4753deb0fe3cb21e7.svg";
export { ForwardRef as ReactComponent };